import { render, staticRenderFns } from "./EmploymentWidget.vue?vue&type=template&id=2d847f33&scoped=true&"
import script from "./EmploymentWidget.vue?vue&type=script&lang=js&"
export * from "./EmploymentWidget.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentWidget.vue?vue&type=style&index=0&id=2d847f33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d847f33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VProgressLinear,VSheet,VTooltip})
